import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

/**
 * Authentication guard with group verification
 * Checks if the user is authenticated and belongs to the stefconnect/admin group
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);

  if (!authService.isAuthenticated()) {
    // Redirect to login if not authenticated
    authService.login();
    return false;
  }

  // Check if user belongs to stefconnect/admin group
  if (!authService.hasGroup('/stefconnect/admin')) {
    // Display error message and logout
    alert('Accès refusé. Vous devez appartenir au groupe stefconnect/admin.');
    authService.logout();
    return false;
  }

  return true;
};
